export default {
  semester_exam: 'Egzamin Semestralny',
  annual_exam: 'Egzamin Roczny',
};
